/* eslint-disable no-unused-expressions */										  
import React, { useState, useEffect, useRef, memo, useReducer, useLayoutEffect, useMemo } from "react";
import DateFormat from "../utils/DateFormat";
import { Box } from "./ui-controls";

const fs = window.require?.('fs');
const path = window.require?.('path');

const CR = '\r\n';
const firstLine = '================================================================================';


// ---predefined global.log
const log = global.logData = ['---init LogView'];
// console.log('---init logView')

let updateView

global.log = (...e) => {
	let inline = e[0] === '' || e[0] === '<';
	e = e.join(' ');
	if (e.startsWith('<')){
		inline = true
		e = e.substring(1)
	}
	console.log('%c' + e, 'color:#f9f');

	if (inline){
		log.length? log[log.length-1] += ' ' + e : log.push(e)

	}else{
		let t = DateFormat('HH:MM:ss.L')
		e = t + '\t' + e
		log.push(e);
	}

	updateView?.()
	return e
}

// let currentDay, logFile, logFilePath, folder;



//----------------------------------------------------------------------------- useLog hook
export const useLog = props => {
	// const log = {}
	// const []

	return log
}


//----------------------------------------------------------------------------- LogView
export default function LogView(props){
	const [, render] = useReducer(e => !e);

	useEffect(() => {
		updateView = render

		return () => {
			updateView = null
		}
	}, [])

	// const log = global.logData;
	// const [log] = useState(e => {
	// 	return {
	// 	}
	// })
	
	// useState(() => {
	// 	console.log('????????????')
	// })

	// useMemo(e => {
	// 	global.log = (...e) => {
	// 		let inline = e[0] === '';
	// 		e = e.join(' ');
	// 		console.log('%c' + e, 'color:#f9f');
	// 		if (inline){
	// 			log.length? log[log.length-1] += ' ' + e : log.push(e)
	// 		}else{
	// 			log.push(e);
	// 		}
	// 		render();
	// 	}
	// }, [])


	// useEffect(() => {
	// 	if (fs && props.folder) initLogFile(props.folder);
	// 	global.log('---init LogView', logFilePath || '');

	// }, [])


	// const initLogFile = (folder) => {
	// 	if (folder.charAt(-1) !== '/') folder += '/';
	// 	logFilePath = folder + DateFormat('yyyy/yyyy-mm-dd') + '.log';
	// 	createPath(logFilePath);

	// 	fs.appendFileSync(logFilePath, CR + '----start log----', 'utf8'); //add cr in first logline
	// }

	
	return (
		<Box>
			{props.children}
			<div className='ui2-log-view'>
				{/* {log.map((e, i) => <div key={i}><span className='ui2-log-index'>{i+1}</span><span>{e}</span></div>)} */}
				{/* use div because span can't use css width */}
				{log.map((e, i) => <div className='ui2-log-row' key={i}>
					<div className='ui2-log-index'>{i+1}</div><span>{e}</span>
				</div>)} 
			</div>
		</Box>
	)
}


//------------------------------------------------------------------------- createPath
const createPath = dir => {
	if (!fs) return;

	if (dir.slice(-1) !== '/') dir = path.dirname(dir);
	let path_ = dir.split('/');
	let p = '';
	path_.forEach(val => {
		if (val !== '' && val !== '.'){
			p += val + '/';
			if (!fs.existsSync(p)) fs.mkdirSync(p);		//create subfolder if not exists
		}
	});
}

